import React from 'react';
import { Route } from 'react-router-dom';

import { MANAGE_PLATFORM_PRIVILEGE_MAP, VIEW_PLATFORM_PRIVILEGE_MAP } from './entity/shared/rbacConstantsService';
import GrantedPrivilegesProvider from './entity/shared/GrantedPrivilegesProvider';
import { ComponentSpinner } from './shared/ComponentSpinner';
import { UnauthorisedPage } from './shared/UnauthorisedPage';
import { useUserContext } from './context/useUserContext';

import { EntityType, PlatformPrivileges } from '../types.generated';

interface RouteInterceptorProps {
    entityType?: EntityType;
    path: string;
    render: () => React.ReactNode;
}

/**
 * Interceptor for routes that require RBAC privileges.
 * Authorises via platform privileges and provides a GrantedPrivilegesContext
 * for the rendered page via GrantedPrivilegesProvider.
 */
export const RouteInterceptor = (props: RouteInterceptorProps) => {
    const { entityType = EntityType.DataProduct, render } = props;
    const { platformPrivileges } = useUserContext();

    const canManage =
        platformPrivileges?.[MANAGE_PLATFORM_PRIVILEGE_MAP[entityType] as keyof PlatformPrivileges] === true;
    const canView = platformPrivileges?.[VIEW_PLATFORM_PRIVILEGE_MAP[entityType] as keyof PlatformPrivileges];

    if (!platformPrivileges) {
        return <ComponentSpinner />;
    }

    if (!(canView || canManage)) {
        return <UnauthorisedPage />;
    }

    return <Route {...props} render={() => <GrantedPrivilegesProvider>{render()}</GrantedPrivilegesProvider>} />;
};
